import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Component, useField, SugaredField } from "@contember/binding";
import { FieldFallbackView } from "./FieldFallbackView.js";
const ImageFieldView = Component(
  ({
    srcField,
    altField,
    titleField,
    formatUrl,
    fallback,
    fallbackStyle,
    ...imgProps
  }) => {
    const srcAccessor = useField(srcField);
    const altAccessor = useField(altField);
    const titleAccessor = useField(titleField);
    if (srcAccessor.value === null) {
      return /* @__PURE__ */ jsx(FieldFallbackView, { fallback, fallbackStyle });
    }
    return (
      // The spread intentionally comes after alt and title so that it's possible to provide just static string values.
      /* @__PURE__ */ jsx(
        "img",
        {
          src: formatUrl ? formatUrl(srcAccessor.value) : srcAccessor.value,
          alt: altAccessor?.value || void 0,
          title: titleAccessor?.value || void 0,
          ...imgProps
        }
      )
    );
  },
  ({ altField, srcField, titleField, fallback, fallbackStyle }) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SugaredField, { field: srcField }),
    altField && /* @__PURE__ */ jsx(SugaredField, { field: altField }),
    titleField && /* @__PURE__ */ jsx(SugaredField, { field: titleField }),
    /* @__PURE__ */ jsx(FieldFallbackView, { fallback, fallbackStyle })
  ] }),
  "ImageFieldView"
);
export {
  ImageFieldView
};
//# sourceMappingURL=ImageFieldView.js.map
